<template>
  <div class="ql-container ql-snow">
    <p class="tradeTipContent ql-editor" v-html="pageInfo"></p>
  </div>
</template>
<script>
import {apiPageInfo} from "@/request/API";

export default {
  name: '',
  props: {
    key1: String,
  },
  components: {

  },
  data () {
    return {
      pageInfo:''
    }
  },
  methods: {
    getPageInfo(){
      apiPageInfo({
        id:this.key1
      }).then(res=>{
        this.pageInfo = res.data.content
      })
    }
  },
  mounted () {
    this.getPageInfo()
  },
  watch: {
    key1(val, oldVal){//普通的watch监听
      this.key1 = val
      this.getPageInfo()
    },
  },
  computed: {

  }
}
</script>

<style scoped>
.ql-container{
  border: none !important;
  min-height: 680px;
  padding: 36px 48px 64px;
  background: var(--bg-card, #FFFFFF);
  color: var(--text-secondary, #5A5F6B);
  box-sizing: border-box;
}
.tradeTipContent{
  padding: 0 !important;
  overflow: auto;
  margin: 0;
  font-size: 15px;
  line-height: 1.9;
  color: var(--text-secondary, #5A5F6B);
  word-break: break-word;
}
.tradeTipContent >>> h1,
.tradeTipContent >>> h2,
.tradeTipContent >>> h3{
  margin: 0 0 16px;
  color: var(--text-main, #111827);
  font-weight: 600;
  line-height: 1.45;
}
.tradeTipContent >>> h2{
  font-size: 22px;
}
.tradeTipContent >>> h3{
  margin-top: 28px;
  font-size: 18px;
}
.tradeTipContent >>> p{
  margin: 0 0 14px;
}
.tradeTipContent >>> ul,
.tradeTipContent >>> ol{
  margin: 10px 0 18px;
  padding-left: 24px;
}
.tradeTipContent >>> li{
  margin-bottom: 8px;
}
.tradeTipContent >>> img{
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  border-radius: 4px;
}
</style>
